<template>
    <div class="mt-2">
        <b-card class="mt-2">
            <h4>Record Class Attendance</h4>
            <p>Record class attendance for today or <a href="#" @click="setCustomDate">pick a different day.</a></p>
            <b-collapse v-model="show_custom_date">
                <b-form-datepicker id="example-datepicker" v-model="custom_date" class="mb-2"></b-form-datepicker>
            </b-collapse>
            <router-link
                :to="{ name: 'teacher_viewPastAttendance'}"
                class="sc-btn pill"
            >
                <font-awesome-icon class="mr-2" icon="history"></font-awesome-icon>
                View Previous Attendance
            </router-link>
            <button
                v-if="can_edit && !editing"
                class="sc-btn pill"
                @click="editAttendanceSheet()"
            >
                <font-awesome-icon icon="pencil-alt" class="mr-2"></font-awesome-icon>
                Edit Attendance
            </button>
            <a
                v-if="pdf_url && pdf_url.length > 0"
                class="sc-btn pill"
                :href="pdf_url"
                target="_blank"
            >
                <font-awesome-icon icon="download" class="mr-2"></font-awesome-icon>
                Download PDF
            </a>
        </b-card>
        <AttendanceList
            :key="custom_date"
            :students="students"
            :class_id="class_.id"
            :date="custom_date"
            @loaded="attendanceSheetLoaded"
        >
            <template
                v-if="editing"
                #default="{ attendanceSheet, refresh }"
            >
                <SaveAttendanceSheet
                    :students="students"
                    :class_id="class_.id"
                    :date="custom_date"
                    :attendanceSheet="attendanceSheet"
                    @saved="() => { editing = false; refresh(); }"
                ></SaveAttendanceSheet>
            </template>
            <template #no-attendance-sheet="{ refresh }">
                <SaveAttendanceSheet
                    :students="students"
                    :class_id="class_.id"
                    :date="custom_date"
                    @saved="refresh()"
                ></SaveAttendanceSheet>
            </template>
        </AttendanceList>
    </div>
</template>
<script>
import AttendanceList      from '../attendance-views/AttendanceList.vue';
import SaveAttendanceSheet from '../attendance-views/SaveAttendanceSheet.vue';
export default {
    props: {
        students: Array,
        class_: Object
    },
    data() {
        // Initialize student attendance
        let studentAttendance = {};
        this.students.forEach((student) => {
            studentAttendance[student.id] = "";
        });
        return {
            editing:  false,
            can_edit: false,
            show_custom_date: false,
            custom_date: null,
            pdf_url: ""
        };
    },
    methods: {
        attendanceSheetLoaded(attendance_sheet, pdf_url) {
            this.can_edit = true;
            this.pdf_url  = pdf_url;
        },
        editAttendanceSheet() {
            this.editing = true;
        },
        setCustomDate(e) {
            if (e) e.preventDefault();
            this.custom_date      = this.$moment().format();
            this.show_custom_date = !this.show_custom_date;
        }
    },
    components: { AttendanceList, SaveAttendanceSheet }
}
</script>